module.exports = __webpack_public_path__ + "static/media/inner spaces.2f10d695.jpg";